import React from "react";
import { departments } from "../../constants";
import { Select } from "antd";
import { DropDownIcon } from "../drop-down-icon";

type DepartmentDropDownProps = {
	value: string | null;
	clearable?: boolean;
	handleChange(e: string): void;
};

export const DepartmentDropDown: React.FunctionComponent<DepartmentDropDownProps> = (props) => {
	const Option = Select;

	return (
		<Select
			className="data_selector form_input"
			placeholder={"Select the department"}
			optionFilterProp={"children"}
			allowClear={props.clearable}
			value={props.value || undefined}
			onChange={(value) => props.handleChange(value)}
			showSearch
			suffixIcon={<DropDownIcon />}
		>
			{departments.map((el: string, i: number) => {
				return (
					<Option key={`user_role_${i}`} value={el}>
						{el}
					</Option>
				);
			})}
		</Select>
	);
};
